import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  ParticipantService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto,
} from '../../services/wealthlane-customer-services';

const usePostPersonalDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto | undefined,
  unknown,
  any,
  unknown
> => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        ParticipantService.putApiCustomerApiAppParticipantPersonalDetailsByParticipant(payload)
      );
    },
    {
      onSuccess: async (
        // eslint-disable-next-line camelcase
        response: Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto | undefined
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Edited successfully!' />);
          await queryClient.invalidateQueries('getParticipantPersonalDetails');
          navigate('/profile');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostPersonalDetails;
